import React from 'react'
// import Menu from '../component/Menu';
import SingleBody from '../component/SingleBody';
import Getintouch2 from '../component/Getintouch2'
import FooterNew from '../component/FooterNew';
import Headersingle from '../component/Headersingle';
// import { Helmet } from 'react-helmet';


const Single = ({setBlank, post_status}) => {

  // <Helmet>
  //   <title></title>
  //   <meta name='description' content=''/>
  //   <meta name='keywords' content=''/>
  // </Helmet>

  return (
    <>
       {/* <Menu /> */}
       <Headersingle setBlank={setBlank} />
       <SingleBody post_status={post_status} /> 
       <Getintouch2 setBlank={setBlank} />
       <FooterNew setBlank={setBlank} />
  
    </>
  )
}

export default Single
